import SecondaryWalletTypeGeneralSettings from "@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletTypeGeneralSettings";
import SecondaryWalletTypeDepositInterestSettings from "@/models/Products/ProductSettings/SecondaryWallets/Savings/SecondaryWalletTypeDepositInterestSettings";
import SecondaryWalletType from "@/models/Products/ProductSettings/SecondaryWallets/General/SecondaryWalletType";

export default class SecondaryWalletTypeViewModel {

    id: string = '';
    generalSettings: SecondaryWalletTypeGeneralSettings = undefined;
    generalSettingsAvailable: boolean = false;
    depositInterestSettings: SecondaryWalletTypeDepositInterestSettings = new SecondaryWalletTypeDepositInterestSettings();
    depositInterestSettingsAvailable: boolean = false;

    public constructor(secondaryWallet: SecondaryWalletType) {
        this.id = secondaryWallet.id;
        this.generalSettings = secondaryWallet.generalSettings;
        if (secondaryWallet.depositInterestSettings) {
            this.depositInterestSettings = secondaryWallet.depositInterestSettings;
            this.depositInterestSettingsAvailable = true;
        }
    }
}